<!-- eslint-disable @angular-eslint/template/eqeqeq -->
@if (isV2()) {
	<div class="statistics-v2" [class.statistics-v2--offline]="offline">
		<app-offline-message *ngIf="offline" [showRetry]="true" (retry)="getStatistics()"></app-offline-message>

		@if (!offline && statistics != undefined) {
			<div class="statistics-v2-grid" *ngIf="dashboardStatisticsMetric$ | async as selectedMetric">
				@for (widget of widgets; track widget.metric) {
					<article
						class="statistics-v2-widget"
					>
						<header class="statistics-v2-widget-header">
							<h3 class="statistics-v2-widget-title">{{ widget.labelKey | transloco }}</h3>
						</header>

						<div class="statistics-v2-widget-body">
							<div class="statistics-v2-hero-card">
								<span class="statistics-v2-period-label">
									{{ "STATISTICS_PAGE__YOUR_SHIFT" | transloco }}
								</span>

								<div class="statistics-v2-hero-value">
									@switch (widget.display) {
										@case ("percent") {
											@if (getValue("userShift", widget.field) != null) {
												<div class="statistics-v2-donut-wrap">
													<svg
														class="statistics-v2-donut"
														viewBox="0 0 160 160"
														aria-hidden="true"
													>
														<circle
															class="statistics-v2-donut-track"
															cx="80"
															cy="80"
															[attr.r]="donutRadius"
														></circle>
														<circle
															class="statistics-v2-donut-progress"
															cx="80"
															cy="80"
															[attr.r]="donutRadius"
															[attr.stroke-dasharray]="donutCircumference"
															[attr.stroke-dashoffset]="
																donutDashOffset(getValue('userShift', widget.field))
															"
														></circle>
													</svg>
													<span class="statistics-v2-donut-label">
														<app-statistics-number
															[value]="getValue('userShift', widget.field)"
															[postfix]="'%'"
															[digitsInfo]="'1.1-1'"
														></app-statistics-number>
													</span>
												</div>
											} @else {
												<span class="statistics-v2-hero-na">
													{{ "STATISTICS_PAGE__NA" | transloco }}
												</span>
											}
										}
										@case ("number") {
											@if (getValue("userShift", widget.field) != null) {
												<span class="statistics-v2-hero-number">
													<app-statistics-number
														[value]="getValue('userShift', widget.field)"
													></app-statistics-number>
												</span>
											} @else {
												<span class="statistics-v2-hero-na">
													{{ "STATISTICS_PAGE__NA" | transloco }}
												</span>
											}
										}
										@case ("time") {
											@if (formatHeroTime(getValue("userShift", widget.field)) != null) {
												<span class="statistics-v2-hero-time">
													{{ formatHeroTime(getValue("userShift", widget.field)) }}
												</span>
											} @else {
												<span class="statistics-v2-hero-na">
													{{ "STATISTICS_PAGE__NA" | transloco }}
												</span>
											}
										}
									}
								</div>
							</div>

							<div class="statistics-v2-metrics">
								<div class="statistics-v2-metric-card">
									<span class="statistics-v2-period-label">
										{{ "STATISTICS_PAGE__TODAY" | transloco }}:
									</span>
									<div class="statistics-v2-metric-value">
										@switch (widget.display) {
											@case ("percent") {
												<app-statistics-number
													[value]="getValue('today', widget.field)"
													[postfix]="'%'"
													[digitsInfo]="'1.1-1'"
												></app-statistics-number>
											}
											@case ("number") {
												<app-statistics-number
													[value]="getValue('today', widget.field)"
												></app-statistics-number>
											}
											@case ("time") {
												@if (formatHeroTime(getValue("today", widget.field)) != null) {
													{{ formatHeroTime(getValue("today", widget.field)) }}
												} @else {
													{{ "STATISTICS_PAGE__NA" | transloco }}
												}
											}
										}
									</div>
								</div>

								<div class="statistics-v2-metric-card">
									<span class="statistics-v2-period-label">
										{{ "STATISTICS_PAGE__LAST_HOUR_SHORT" | transloco }}:
									</span>
									<div class="statistics-v2-metric-value">
										@switch (widget.display) {
											@case ("percent") {
												<app-statistics-number
													[value]="getValue('lastHour', widget.field)"
													[postfix]="'%'"
													[digitsInfo]="'1.1-1'"
												></app-statistics-number>
											}
											@case ("number") {
												<app-statistics-number
													[value]="getValue('lastHour', widget.field)"
												></app-statistics-number>
											}
											@case ("time") {
												@if (formatHeroTime(getValue("lastHour", widget.field)) != null) {
													{{ formatHeroTime(getValue("lastHour", widget.field)) }}
												} @else {
													{{ "STATISTICS_PAGE__NA" | transloco }}
												}
											}
										}
									</div>
								</div>
							</div>
						</div>
					</article>
				}
			</div>
		}
	</div>
} @else {
	<div class="statistics-container">
		<div class="header-container">
			<div class="headline">
				<h1>{{ "STATISTICS_PAGE__HEADLINE" | transloco }}</h1>
				<h3>{{ "STATISTICS_PAGE__SUB_HEADLINE" | transloco }}</h3>
			</div>
			<ion-icon name="close" (click)="close()"></ion-icon>
		</div>

		<app-offline-message *ngIf="offline" [showRetry]="true" (retry)="getStatistics()"></app-offline-message>

		<table *ngIf="!offline && statistics != undefined" class="statistics-table">
			<tr>
				<td></td>
				<td class="header column-header">
					{{ "STATISTICS_PAGE__TODAY" | transloco }}
				</td>
				<td class="header column-header">
					{{ "STATISTICS_PAGE__LAST_HOUR" | transloco }}
				</td>
				<td class="header column-header">
					{{ "STATISTICS_PAGE__YOUR_SHIFT" | transloco }}
				</td>
			</tr>

			<tr class="border-bottom">
				<td (click)="select(StatisticsMetric.CapacityUtilization)" class="header row-header">
					<ion-icon
						name="{{
							(dashboardStatisticsMetric$ | async) == StatisticsMetric.CapacityUtilization
								? 'checkmark-circle'
								: 'ellipse-outline'
						}}"
					></ion-icon>
					<span>{{ "STATISTICS_PAGE__RIDE_UTILIZATION" | transloco }}</span>
				</td>
				<td>
					<app-statistics-number
						[value]="statistics.today.rideUtilization"
						[postfix]="'%'"
						[digitsInfo]="'1.1-1'"
					></app-statistics-number>
				</td>
				<td>
					<app-statistics-number
						[value]="statistics.lastHour.rideUtilization"
						[postfix]="'%'"
						[digitsInfo]="'1.1-1'"
					></app-statistics-number>
				</td>
				<td>
					<app-statistics-number
						[value]="statistics.userShift.rideUtilization"
						[postfix]="'%'"
						[digitsInfo]="'1.1-1'"
					></app-statistics-number>
				</td>
			</tr>

			<tr class="border-bottom">
				<td (click)="select(StatisticsMetric.DispatchUtilization)" class="header row-header">
					<ion-icon
						name="{{
							(dashboardStatisticsMetric$ | async) == StatisticsMetric.DispatchUtilization
								? 'checkmark-circle'
								: 'ellipse-outline'
						}}"
					></ion-icon>
					<span>{{ "STATISTICS_PAGE__CART_UTILIZATION" | transloco }}</span>
				</td>
				<td>
					<app-statistics-number
						[value]="statistics.today.cartUtilization"
						[postfix]="'%'"
						[digitsInfo]="'1.1-1'"
					></app-statistics-number>
				</td>
				<td>
					<app-statistics-number
						[value]="statistics.lastHour.cartUtilization"
						[postfix]="'%'"
						[digitsInfo]="'1.1-1'"
					></app-statistics-number>
				</td>
				<td>
					<app-statistics-number
						[value]="statistics.userShift.cartUtilization"
						[postfix]="'%'"
						[digitsInfo]="'1.1-1'"
					></app-statistics-number>
				</td>
			</tr>

			<tr class="border-bottom">
				<td (click)="select(StatisticsMetric.Dispatches)" class="header row-header">
					<ion-icon
						name="{{
							(dashboardStatisticsMetric$ | async) == StatisticsMetric.Dispatches
								? 'checkmark-circle'
								: 'ellipse-outline'
						}}"
					></ion-icon>
					<span>{{ "STATISTICS_PAGE__DISPATCHES" | transloco }}</span>
				</td>
				<td>
					<app-statistics-number [value]="statistics.today.dispatches"></app-statistics-number>
				</td>
				<td>
					<app-statistics-number [value]="statistics.lastHour.dispatches"></app-statistics-number>
				</td>
				<td>
					<app-statistics-number [value]="statistics.userShift.dispatches"></app-statistics-number>
				</td>
			</tr>

			<tr class="border-bottom">
				<td (click)="select(StatisticsMetric.Riders)" class="header row-header">
					<ion-icon
						name="{{
							(dashboardStatisticsMetric$ | async) == StatisticsMetric.Riders
								? 'checkmark-circle'
								: 'ellipse-outline'
						}}"
					></ion-icon>
					<span>{{ "STATISTICS_PAGE__RIDERS" | transloco }}</span>
				</td>
				<td>
					<app-statistics-number [value]="statistics.today.riders"></app-statistics-number>
				</td>
				<td>
					<app-statistics-number [value]="statistics.lastHour.riders"></app-statistics-number>
				</td>
				<td>
					<app-statistics-number [value]="statistics.userShift.riders"></app-statistics-number>
				</td>
			</tr>

			<tr class="border-bottom">
				<td (click)="select(StatisticsMetric.AverageDispatchTime)" class="header row-header">
					<ion-icon
						name="{{
							(dashboardStatisticsMetric$ | async) == StatisticsMetric.AverageDispatchTime
								? 'checkmark-circle'
								: 'ellipse-outline'
						}}"
					></ion-icon>
					<span>{{ "STATISTICS_PAGE__AVG_CYCLE_TIME" | transloco }}</span>
				</td>
				<td>
					<app-statistics-time [totalSeconds]="statistics.today.averageTime"></app-statistics-time>
				</td>
				<td>
					<app-statistics-time [totalSeconds]="statistics.lastHour.averageTime"></app-statistics-time>
				</td>
				<td>
					<app-statistics-time [totalSeconds]="statistics.userShift.averageTime"></app-statistics-time>
				</td>
			</tr>

			<tr>
				<td (click)="select(StatisticsMetric.Uptime)" class="header row-header">
					<ion-icon
						name="{{
							(dashboardStatisticsMetric$ | async) == StatisticsMetric.Uptime
								? 'checkmark-circle'
								: 'ellipse-outline'
						}}"
					></ion-icon>
					<span>{{ "STATISTICS_PAGE__UPTIME" | transloco }}</span>
				</td>
				<td>
					<app-statistics-time [totalSeconds]="statistics.today.uptime"></app-statistics-time>
				</td>
				<td>
					<app-statistics-time [totalSeconds]="statistics.lastHour.uptime"></app-statistics-time>
				</td>
				<td>
					<app-statistics-time [totalSeconds]="statistics.userShift.uptime"></app-statistics-time>
				</td>
			</tr>
		</table>
	</div>
}
